// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__30yhm","icon":"style_icon__2u5zo","dropdownGray":"style_dropdownGray__3_6al","dropdownDark":"style_dropdownDark__aLOEs","title":"style_title__2EiuE"};